import { Box, Tab, Tabs } from "@mui/material";
import { useState, type SyntheticEvent } from "react";
import { FormikTextField } from "../narrative/EditableFields";

const assessmentReportFields = [
  {
    name: "assessmentReport.developerInfo",
    id: "assessment-report-developer-information",
    label: "Developer Information",
  },
  {
    name: "assessmentReport.sdgInfo",
    id: "assessment-report-sdg-information",
    label: "SDG Information",
  },
  {
    name: "assessmentReport.monitoringInfo",
    id: "assessment-report-monitoring-information",
    label: "Monitoring Information",
  },
  {
    name: "assessmentReport.locationInfo",
    id: "assessment-report-location-information",
    label: "Location Information",
  },
] as const;

function AssessmentReportEditableFields() {
  const [selectedTab, setSelectedTab] = useState(0);
  const handleTabChange = (_event: SyntheticEvent, nextTab: number) =>
    setSelectedTab(nextTab);

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          aria-label="Assessment report sections"
          variant="scrollable"
          scrollButtons="auto"
        >
          {assessmentReportFields.map(({ id, label }, index) => (
            <Tab
              key={id}
              label={label}
              id={`solution-assessment-report-form-tab-${index}`}
              aria-controls={`solution-assessment-report-tabpanel-${index}`}
            />
          ))}
        </Tabs>
      </Box>

      <FormikTextField
        name={assessmentReportFields[selectedTab].name}
        id={assessmentReportFields[selectedTab].id}
        label={assessmentReportFields[selectedTab].label}
        helperText="Paragraphs, lists and links are supported."
      />
    </>
  );
}

export default AssessmentReportEditableFields;
